module.exports = __webpack_public_path__ + "static/media/comp250.c596938d.png";